import React from "react";

import { ConnectWithUs, Layout } from "../../components";
import { Center, Divider } from "../../components/ui";
import FeedbackForm from "../../components/feedback-form";

import styles from "./index.module.css";

const ContactsPage = () => {
  return (
    <Layout>
      <Center>
        <div className={styles.formContainer}>
          <FeedbackForm title="Остались вопросы? Напишите нам:" withShadow />
        </div>
      </Center>
      <Divider />
      <Center>
        <ConnectWithUs />
      </Center>
    </Layout>
  );
};

export default ContactsPage;
